<template>
  <div class="followAccount">
    <div class="bscroll" ref="bscroll">
      <div class="bscroll-container">
        <div class="mobileFilterDiv" v-if="mobileFlag">
          <div>
            <el-button class="mobileFilterBtn" @click="addFollow(true)">
              {{ $t("Common_Operate_AddInvite") }}
              <i class="el-icon-plus el-icon--right"></i>
            </el-button>
          </div>
          <el-button
            class="mobileFilterBtn"
            @click="mobileSearchDrawer = true"
            type="text"
            size="small"
          >
            {{ $t("Common_Operation_Filter") }}
            <svg-icon class="greenIcon" icon-class="MobileFilterBtn"></svg-icon>
          </el-button>
        </div>

        <div class="tableSearch" v-if="!mobileFlag">
          <el-form
            label-position="top"
            :model="tableSearchForm"
            ref="tableSearchForm"
          >
            <el-form-item
              :label="$t('Common_TableTitle_Mt4Account')"
              prop="Account"
            >
              <el-input v-model="tableSearchForm.Account"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Common_TableTitle_CustomerEmail')"
              prop="LoginId"
            >
              <el-input v-model="tableSearchForm.LoginId"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Common_TableTitle_AutoMatchOrder')"
              prop="AutoRecon"
            >
              <el-select v-model="tableSearchForm.AutoRecon">
                <el-option :label="$t('Common_Yes')" value="true"></el-option>
                <el-option :label="$t('Common_No')" value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('Common_TableTitle_Status')"
              prop="FollowStatus"
            >
              <el-select v-model="tableSearchForm.FollowStatus">
                <el-option :label="$t('Common_AllStatus')" value=""></el-option>
                <el-option
                  :label="$t('Common_InvitationStatus_Inviting0')"
                  value="0"
                ></el-option>
                <el-option
                  :label="$t('Common_InvitationStatus_AgreeWatingActivate4')"
                  value="4"
                ></el-option>
                <el-option
                  :label="$t('Common_InvitationStatus_BeRefuse2')"
                  value="2"
                ></el-option>
                <el-option
                  :label="$t('Common_InvitationStatus_Agree1')"
                  value="1"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="noLabel">
              <el-button
                class="serchFormBtn"
                @click="getData(1, pageSize, 'search')"
              >
                {{ $t("Common_Search") }}
                <svg-icon icon-class="SearchIcon"></svg-icon>
              </el-button>
            </el-form-item>
            <el-form-item class="noLabel">
              <el-button class="resetFormBtn" @click="resetForm()">
                {{ $t("Common_Reset") }}
                <svg-icon icon-class="ResetIcon"></svg-icon>
              </el-button>
            </el-form-item>
            <el-form-item class="noLabel">
              <el-button class="serchFormBtn" @click="addFollow(true)">
                {{ $t("Common_Operate_AddInvite") }}
                <i class="el-icon-plus el-icon--right"></i>
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableDiv" v-if="!mobileFlag">
          <el-table
            :data="tableData"
            style="width: 100%"
            ref="dataTable"
            :summary-method="getSummaries"
            show-summary
          >
            <el-table-column
              width="80"
              v-if="!mobileFlag"
              prop="sortNum"
              :label="$t('Common_TableTitle_Number')"
            >
            </el-table-column>
            <el-table-column
              :width="flexLabelWidth($t('Common_TableTitle_CustomerEmail'))"
              prop="followLoginId"
              :label="$t('Common_TableTitle_CustomerEmail')"
            >
            </el-table-column>
            <el-table-column
              :width="flexLabelWidth($t('Common_TableTitle_Mt4Account'))"
              prop="followAccount"
              :label="$t('Common_TableTitle_Mt4Account')"
            >
             <template slot-scope="scope">
                <div>
                  {{
                     scope.row.mtType? (scope.row.mtType+'.') + scope.row.followAccount :"" + scope.row.followAccount
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="notSettlementProfit"
              :label="$t('Common_TableTitle_WaitingSettlementProfit')"
            >
              <template slot="header">
                <div class="tableHeaderDiv label-box">
                  <span
                    >{{ $t("Common_TableTitle_WaitingSettlementProfit") }}
                  </span>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      {{ $t("Settlement_ProfitSharingInstructions") }}<br />{{
                        $t("Settlement_ProfitSharingInstructionsOne")
                      }}<br />{{
                        $t("Settlement_ProfitSharingInstructionsTwo")
                      }}
                    </div>
                    <a
                      href="javascript:;"
                      @click.stop="
                        labelIconClick(
                          $t('Common_TableTitle_WaitingSettlementProfit'),
                          $t('ToBeDividedDesc')
                        )
                      "
                    >
                      <svg-icon
                        class="labelIcon"
                        icon-class="LabelIcon"
                      ></svg-icon>
                    </a>
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                {{
                  scope.row.notSettlementProfit
                    ? formatNumberFractionDigits(scope.row.notSettlementProfit)
                    : "0.00"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="beginPeriodEquity"
              :label="$t('Common_TableTitle_InitialEquity')"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.beginPeriodEquity
                      ? formatNumberFractionDigits(scope.row.beginPeriodEquity)
                      : "0.00"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="currentPeriodDeposit"
              :label="$t('Common_TableTitle_CurrentPeriodDeposit')"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.currentPeriodDeposit
                      ? formatNumberFractionDigits(
                          scope.row.currentPeriodDeposit
                        )
                      : "0.00"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="equity"
              :label="$t('Common_TableTitle_CurrentEquity')"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.equity
                      ? formatNumberFractionDigits(scope.row.equity)
                      : "0.00"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="balance"
              :label="$t('Common_TableTitle_CurrentBalance')"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.balance
                      ? formatNumberFractionDigits(scope.row.balance)
                      : "0.00"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="profit"
              :label="$t('Common_TableTitle_CurrentProfitLoss')"
            >
              <template slot-scope="scope">
                <div
                  :class="[
                    scope.row.profit > 0
                      ? 'greenNum'
                      : scope.row.profit < 0
                      ? 'redNum'
                      : '',
                  ]"
                >
                  {{
                    scope.row.profit > 0
                      ? "+" + formatNumberFractionDigits(scope.row.profit)
                      : scope.row.profit < 0
                      ? formatNumberFractionDigits(scope.row.profit)
                      : "0.00"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="totalCompleteProfit"
              :label="$t('Common_TableTitle_CompleteSettlementProfit')"
            >
              <template slot-scope="scope">
                <div
                  class="clickClass"
                  @click="goHistoryProfit(scope.row.followAccount)"
                >
                  {{
                    scope.row.totalCompleteProfit
                      ? formatNumberFractionDigits(
                          scope.row.totalCompleteProfit
                        )
                      : "0.00"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="totalProfit"
              :label="$t('Common_TableTitle_ProfitLoss')"
            >
              <template slot-scope="scope">
                <div
                  :class="[
                    scope.row.totalProfit > 0
                      ? 'greenNum'
                      : scope.row.totalProfit < 0
                      ? 'redNum'
                      : '',
                  ]"
                >
                  {{
                    scope.row.totalProfit > 0
                      ? "+" + formatNumberFractionDigits(scope.row.totalProfit)
                      : scope.row.totalProfit < 0
                      ? formatNumberFractionDigits(scope.row.totalProfit)
                      : "0.00"
                  }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              :width="flexLabelWidth($t('Common_TableTitle_CopyRatio'))"
              :label="$t('Common_TableTitle_CopyRatio')"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.following + "%" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="maxVolume"
              width="100"
              :label="$t('Common_TableTitle_MaxLot')"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.maxVolume == 0
                      ? $t("Common_TR_VolumeNotLimit")
                      : scope.row.maxVolume + "lots"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="currentPeriodVolumes"
              :label="$t('Common_TableTitle_CurrentPeriodVolumes')"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.currentPeriodVolumes + "lots" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="currentSettlementBeginTime"
              width="150"
              :label="$t('Common_TableTitle_CurrentBeginTime')"
            >
            </el-table-column>
            <el-table-column
              width="160"
              :label="$t('Common_TableTitle_AutoMatchOrder')"
            >
              <template slot-scope="scope">
                <div>
                  <el-result
                    v-if="scope.row.autoRecon"
                    icon="success"
                  ></el-result>
                  <el-result
                    v-if="!scope.row.autoRecon"
                    icon="error"
                  ></el-result>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :width="
                mobileFlag ? 150 : flexLabelWidth($t('Common_LoginStatus'))
              "
              prop="mtApiLoginStatus"
              :label="$t('Common_LoginStatus')"
            >
              <template slot-scope="scope">
                <div>
                  <div
                    class="loginStatus"
                    v-if="scope.row.mtApiLoginStatus == 0"
                  >
                    <el-result icon="success"></el-result>
                    <span>{{ $t("Common_LoginStatusOnline") }}</span>
                  </div>
                  <div
                    class="loginStatus"
                    v-if="scope.row.mtApiLoginStatus !== 0"
                  >
                    <el-result icon="error"></el-result>
                    <span>{{ $t("Common_LoginStatusOutline") }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="symbols"
              width="135"
              :label="$t('Common_TableTitle_Instruments')"
            >
              <template slot-scope="scope">
                <div>
                  <span class="symbolsSpan" v-if="scope.row.forexSelect">
                    {{ $t("Common_Fx") }}
                  </span>
                  <span class="symbolsSpan" v-if="scope.row.metalsSelect">
                    {{ $t("Common_Metal") }}
                  </span>
                  <span class="symbolsSpan" v-if="scope.row.energySelect">
                    {{ $t("Common_Energy") }}
                  </span>
                  <span class="symbolsSpan" v-if="scope.row.indicesSelect">
                    {{ $t("Common_Indices") }}
                  </span>
                  <span class="symbolsSpan" v-if="scope.row.cryptoSelect">
                    {{ $t("Common_Crypto") }}
                  </span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="140"
              :label="$t('Common_TableTitle_Status')"
              class="statusBr"
            >
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.status == 0" class="statusGreen">{{
                    $t("Common_InvitationStatus_Inviting0")
                  }}</span>
                  <span v-if="scope.row.status == 4" class="statusYellow">{{
                    $t("Common_InvitationStatus_AgreeWatingActivate4")
                  }}</span>
                  <span v-if="scope.row.status == 2" class="statusRed">{{
                    $t("Common_InvitationStatus_BeRefuse2")
                  }}</span>
                  <span v-if="scope.row.status == 1" class="statusYellow">{{
                    $t("Common_InvitationStatus_Agree1")
                  }}</span>
                  <span v-if="scope.row.status == 3" class="statusRed">{{
                    $t("Common_InvitationStatus_Stop3")
                  }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              :fixed="tableData.length !== 0 ? 'right' : false"
              v-if="!mobileFlag"
              width="135"
              :label="$t('Common_TableTitle_Operation')"
            >
              <template slot-scope="scope">
                <div class="operateBtns">
                  <el-button
                    v-if="scope.row.status == 4"
                    @click="activateFollow(scope.row)"
                    type="text"
                    size="small"
                    v-loading.fullscreen.lock="fullscreenLoading"
                  >
                    <svg-icon
                      class="greenIcon"
                      icon-class="ActivateIcon"
                    ></svg-icon>
                    {{ $t("Common_TableTitle_ActivationStatus") }}
                  </el-button>

                  <el-button
                    v-if="
                      scope.row.status !== 1 &&
                      scope.row.status !== 4 &&
                      scope.row.status !== 3
                    "
                    @click="retractFollow(scope.row)"
                    type="text"
                    size="small"
                    v-loading.fullscreen.lock="fullscreenLoading"
                  >
                    <svg-icon
                      class="greenIcon"
                      icon-class="RetractIcon"
                    ></svg-icon>
                    {{ $t("Common_Operate_DeleteInvite") }}
                  </el-button>
                  <el-button
                    v-if="scope.row.status == 0 || scope.row.status == 2"
                    @click="editFollow(scope.row)"
                    type="text"
                    size="small"
                    v-loading.fullscreen.lock="fullscreenLoading"
                  >
                    <svg-icon
                      class="greenIcon"
                      icon-class="SettingIcon"
                    ></svg-icon>
                    {{ $t("Common_Setting") }}
                  </el-button>
                  <el-button
                    @click="settleUnbind(scope.row)"
                    v-if="scope.row.status == 1"
                    type="text"
                    size="small"
                    v-loading.fullscreen.lock="fullscreenLoading"
                  >
                    <svg-icon
                      class="greenIcon"
                      icon-class="RelieveIcon"
                    ></svg-icon>
                    {{ $t("Common_Operation_SettleAndUnbind") }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="mobileFlag"
              :fixed="tableData.length !== 0 ? 'right' : false"
              width="80"
              :label="$t('Common_TableTitle_Operation')"
            >
              <template slot-scope="scope">
                <div class="operateBtns">
                  <el-popover placement="bottom-end" trigger="click">
                    <el-button
                      v-if="scope.row.status == 4"
                      @click="activateFollow(scope.row)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="ActivateIcon"
                      ></svg-icon>
                      {{ $t("Common_TableTitle_ActivationStatus") }}
                    </el-button>
                    <el-button
                      v-if="scope.row.status !== 1 && scope.row.status !== 4"
                      @click="retractFollow(scope.row)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="RetractIcon"
                      ></svg-icon>
                      {{ $t("Common_Operate_DeleteInvite") }}
                    </el-button>
                    <el-button
                      v-if="scope.row.status == 0 || scope.row.status == 2"
                      @click="editFollow(scope.row)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="SettingIcon"
                      ></svg-icon>
                      {{ $t("Common_Setting") }}
                    </el-button>
                    <i
                      slot="reference"
                      class="mobileSetting el-icon-setting"
                    ></i>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="tableTotalNum">
            {{
              $t("Common_TableTotalvolumns") +
              " : " +
              totalVolume +
              "&nbsp;&nbsp;&nbsp;&nbsp;" +
              $t("Common_TableTotalprofit") +
              " : " +
              totalProfit +
              " "
            }}
          </div>
          <el-pagination
            class="tablePage"
            :prev-text="$t('Common_PreviousPage')"
            :next-text="$t('Common_NexPage')"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            @size-change="handleSizeChange"
            :page-sizes="[5, 10, 20, 50, 100]"
            layout="prev, pager, next, sizes"
            :total="total"
          >
          </el-pagination>
        </div>
        <div class="mobileTableList" v-show="mobileFlag">
          <div class="tableTotalTop">
            <span>{{ $t("Common_TableTotalvolumns") }}</span>
            <b>
              {{ totalVolume }}
            </b>
          </div>
          <div class="tableTotalTop">
            <span>{{ $t("Common_TableTotalprofit") }}</span>
            <b :class="[totalProfit > 0 ? 'greenNum' : 'redNum']">
              {{ totalProfit }}
            </b>
          </div>
          <el-collapse accordion @change="collapseChange">
            <el-collapse-item v-for="(item, index) in tableData" :key="index">
              <template slot="title">
                <div class="mobileTableCard" @click.stop="showCollapse()">
                  <div class="mobileTableItem mobileTableStatusTitle">
                    <div>
                      <span v-if="item.status == 0" class="statusGreen">{{
                        $t("Common_InvitationStatus_Inviting0")
                      }}</span>
                      <span v-if="item.status == 4" class="statusYellow">{{
                        $t("Common_InvitationStatus_AgreeWatingActivate4")
                      }}</span>
                      <span v-if="item.status == 2" class="statusRed">{{
                        $t("Common_InvitationStatus_BeRefuse2")
                      }}</span>
                      <span v-if="item.status == 1" class="statusYellow">{{
                        $t("Common_InvitationStatus_Agree1")
                      }}</span>
                      <span v-if="item.status == 3" class="statusRed">{{
                        $t("Common_InvitationStatus_Stop3")
                      }}</span>
                    </div>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_CustomerEmail") }}
                    </p>
                    <p class="mobileTableContent">
                      {{ item.followLoginId }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_Mt4Account") }}
                    </p>
                    <p
                      class="mobileTableContent mobileUnderline"
                      v-if="item.status == 1"
                    >
                      {{ item.mtType }}.{{ item.followAccount }}
                    </p>
                    <p class="mobileTableContent" v-else>
                     -
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle labelIconDiv">
                      {{ $t("Common_TableTitle_WaitingSettlementProfit") }}
                      <a
                        href="javascript:;"
                        class="labelIconDivMobile"
                        @click.stop="
                          labelIconClick(
                            $t('Common_TableTitle_WaitingSettlementProfit'),
                            $t('Settlement_ProfitSharingInstructionsOne'),
                            $t('Settlement_ProfitSharingInstructionsTwo')
                          )
                        "
                      >
                        <svg-icon
                          class="labelIcon"
                          icon-class="LabelIcon"
                        ></svg-icon>
                      </a>
                    </p>
                    <p class="mobileTableContent">
                      {{ formatNumberFractionDigits(item.notSettlementProfit) }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_InitialEquity") }}
                    </p>
                    <p class="mobileTableContent">
                      {{ formatNumberFractionDigits(item.beginPeriodEquity) }}
                    </p>
                  </div>
                </div>
                <div class="mobileTableBtns" @click.stop="showCollapse()">
                  <el-button
                    class="mobileBlueBtn"
                    v-if="item.status == 4"
                    @click="activateFollow(item)"
                    type="text"
                    size="small"
                    v-loading.fullscreen.lock="fullscreenLoading"
                  >
                    <svg-icon
                      class="greenIcon"
                      icon-class="ActivateIcon"
                    ></svg-icon>
                    {{ $t("Common_TableTitle_ActivationStatus") }}
                  </el-button>
                  <el-button
                    class="mobileRedBtn"
                    v-if="item.status !== 1 && item.status !== 4"
                    @click="retractFollow(item)"
                    type="text"
                    size="small"
                    v-loading.fullscreen.lock="fullscreenLoading"
                  >
                    <svg-icon
                      class="greenIcon"
                      icon-class="RetractIcon"
                    ></svg-icon>
                    {{ $t("Common_Operate_DeleteInvite") }}
                  </el-button>
                  <el-button
                    class="mobileBlueBtn"
                    v-if="item.status == 0 || item.status == 2"
                    @click="editFollow(item)"
                    type="text"
                    size="small"
                    v-loading.fullscreen.lock="fullscreenLoading"
                  >
                    <svg-icon
                      class="greenIcon"
                      icon-class="SettingIcon"
                    ></svg-icon>
                    {{ $t("Common_Setting") }}
                  </el-button>

                  <el-button
                    class="mobileBlueBtn"
                    v-if="item.status == 1"
                    @click="settleUnbind(item)"
                    type="text"
                    size="small"
                    v-loading.fullscreen.lock="fullscreenLoading"
                  >
                    <svg-icon
                      class="greenIcon"
                      icon-class="RelieveIcon"
                    ></svg-icon>
                    {{ $t("Common_Operation_SettleAndUnbind") }}
                  </el-button>
                </div>
              </template>
              <div class="mobileTableCard">
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_CurrentPeriodDeposit") }}
                  </p>
                  <p class="mobileTableContent">
                    {{ formatNumberFractionDigits(item.currentPeriodDeposit) }}
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_CurrentEquity") }}
                  </p>
                  <p class="mobileTableContent">
                    {{ formatNumberFractionDigits(item.equity) }}
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_CurrentBalance") }}
                  </p>
                  <p class="mobileTableContent">
                    {{ formatNumberFractionDigits(item.balance) }}
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_CurrentProfitLoss") }}
                  </p>
                  <p
                    :class="[
                      item.profit > 0
                        ? 'greenNum'
                        : item.profit < 0
                        ? 'redNum'
                        : '',
                      'mobileTableContent',
                    ]"
                  >
                    {{
                      item.profit > 0
                        ? "+" + formatNumberFractionDigits(item.profit)
                        : item.profit < 0
                        ? formatNumberFractionDigits(item.profit)
                        : "0.00"
                    }}
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_CompleteSettlementProfit") }}
                  </p>
                  <p
                    class="mobileTableContent clickClass"
                    @click="goHistoryProfit(item.followAccount)"
                  >
                    {{ formatNumberFractionDigits(item.totalCompleteProfit) }}
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTotalprofit") }}
                  </p>
                  <p
                    :class="[
                      item.totalProfit > 0
                        ? 'greenNum'
                        : item.totalProfit < 0
                        ? 'redNum'
                        : '',
                      'mobileTableContent',
                    ]"
                  >
                    {{
                      item.totalProfit > 0
                        ? "+" + formatNumberFractionDigits(item.totalProfit)
                        : item.totalProfit < 0
                        ? formatNumberFractionDigits(item.totalProfit)
                        : "0.00"
                    }}
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_CopyRatio") }}
                  </p>
                  <p class="mobileTableContent">
                    {{ item.following + "%" }}
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_MaxLot") }}
                  </p>
                  <p class="mobileTableContent">
                    {{
                      item.maxVolume == 0
                        ? $t("Common_TR_VolumeNotLimit")
                        : item.maxVolume + " lots"
                    }}
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_CurrentPeriodVolumes") }}
                  </p>
                  <p class="mobileTableContent">
                    {{ item.currentPeriodVolumes + "lots" }}
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_CurrentBeginTime") }}
                  </p>
                  <p class="mobileTableContent">
                    {{ item.currentSettlementBeginTime }}
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_AutoMatchOrder") }}
                  </p>
                  <p class="mobileTableContent">
                    <el-result v-if="item.autoRecon" icon="success"></el-result>
                    <el-result v-if="!item.autoRecon" icon="error"></el-result>
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_LoginStatus") }}
                  </p>
                  <p
                    class="mobileTableContent loginStatus"
                    v-if="item.mtApiLoginStatus == 0"
                  >
                    <el-result icon="success"></el-result>
                    <span>{{ $t("Common_LoginStatusOnline") }}</span>
                  </p>
                  <p class="mobileTableContent loginStatus" v-else>
                    <el-result icon="error"></el-result>
                    <span>{{ $t("Common_LoginStatusOutline") }}</span>
                  </p>
                </div>
                <div class="mobileTableItem">
                  <p class="mobileTableTitle">
                    {{ $t("Common_TableTitle_Instruments") }}
                  </p>
                  <p class="mobileTableContent">
                    <span class="symbolsSpan" v-if="item.forexSelect">
                      {{ $t("Common_Fx") }}
                    </span>
                    <span class="symbolsSpan" v-if="item.metalsSelect">
                      {{ $t("Common_Metal") }}
                    </span>
                    <span class="symbolsSpan" v-if="item.energySelect">
                      {{ $t("Common_Energy") }}
                    </span>
                    <span class="symbolsSpan" v-if="item.indicesSelect">
                      {{ $t("Common_Indices") }}
                    </span>
                    <span class="symbolsSpan" v-if="item.cryptoSelect">
                      {{ $t("Common_Crypto") }}
                    </span>
                  </p>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="x" v-if="up && tableData.length < total">
            <i class="el-icon-loading"></i>
            {{ $t("Common_Loading") }}
          </div>
          <div class="x" v-if="!up && tableData.length >= total">
            {{ $t("Common_NoMoreData") }}
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      :title="followAccountDrawerTitle"
      class="drawerCommon"
      :append-to-body="true"
      @close="cancelDrawer()"
      :close-on-press-escape="false"
      :visible.sync="followAccountDrawer"
      direction="rtl"
    >
      <div class="drawerContent">
        <el-form
          :model="followForm"
          :rules="rules"
          ref="followForm"
          label-width="150px"
          class="drawerForm"
          :label-position="mobileFlag ? 'top' : 'right'"
        >
          <el-form-item
            :label="$t('Common_TableTitle_CustomerEmail')"
            prop="loginId"
          >
            <el-input
              :disabled="isEdit"
              v-model="followForm.loginId"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item prop="following">
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_CopyRatio") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_CopyRatio'),
                      $t('ViewInvitation_CopyPercentTxt'),
                      $t('ViewInvitation_CopyPercentTxt1')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i>
                  <div>
                    <div>
                      {{ $t("ViewInvitation_CopyPercentTxt") }}
                    </div>
                    <br />
                    <div>
                      {{ $t("ViewInvitation_CopyPercentTxt1") }}
                    </div>
                  </div>
                </div>
              </span>
            </span>
            <el-input
              :disabled="isStatusDisabled"
              v-model.number="followForm.following"
              autocomplete="off"
            ></el-input>
            <b class="formPercent">%</b>
          </el-form-item>
          <el-form-item prop="maxVolume">
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_MaxLot") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_MaxLot'),
                      $t('ViewInvitation_MaxVolumnTxt')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i>
                  <div>
                    <div>
                      {{ $t("ViewInvitation_MaxVolumnTxt") }}
                    </div>
                    <br />
                    <div>
                      {{ $t("ViewInvitation_MaxVolumnTxt1") }}
                    </div>
                  </div>
                </div>
              </span>
            </span>
            <el-input-number
              :disabled="isStatusDisabled"
              :precision="2"
              class="creaseInput"
              controls-position="right"
              :min="0"
              v-model.number="followForm.maxVolume"
              autocomplete="off"
              :placeholder="$t('Common_TR_VolumeNotLimit')"
            ></el-input-number>
            <b class="formLots">lots</b>
          </el-form-item>
          <el-form-item
            :label="$t('Common_TableTitle_Instruments')"
            prop="symbolsCheck"
          >
            <el-checkbox
              v-model="followForm.forexSelect"
              :disabled="isStatusDisabled"
              >{{ $t("Common_Fx") }}</el-checkbox
            >
            <el-checkbox
              v-model="followForm.metalsSelect"
              :disabled="isStatusDisabled"
              >{{ $t("Common_Metal") }}</el-checkbox
            >
            <el-checkbox
              v-model="followForm.energySelect"
              :disabled="isStatusDisabled"
              >{{ $t("Common_Energy") }}</el-checkbox
            >
            <el-checkbox
              v-model="followForm.indicesSelect"
              :disabled="isStatusDisabled"
              >{{ $t("Common_Indices") }}</el-checkbox
            >
            <el-checkbox
              v-model="followForm.cryptoSelect"
              :disabled="isStatusDisabled"
              >{{ $t("Common_Crypto") }}</el-checkbox
            >
          </el-form-item>
          <el-form-item prop="autoRecon">
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_AutoMatchOrder") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_AutoMatchOrder'),
                      $t('ViewInvitation_IsAutoTxt')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i
                  >{{ $t("ViewInvitation_IsAutoTxt") }}
                </div>
              </span>
            </span>
            <el-radio-group
              v-model="followForm.autoRecon"
              :disabled="isStatusDisabled"
            >
              <el-radio :label="true">{{ $t("Common_Yes") }}</el-radio>
              <el-radio :label="false">{{ $t("Common_No") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            prop="agreeActivation"
            :label="$t('Common_TableTitle_ActivationStatus')"
          >
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_ActivationStatus") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_ActivationStatus'),
                      $t('ViewInvitation_MainActiveTxt')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i
                  >{{ $t("ViewInvitation_MainActiveTxt") }}
                </div>
              </span>
            </span>
            <el-radio-group
              v-model="followForm.agreeActivation"
              :disabled="isStatusDisabled"
            >
              <el-radio :label="true">{{ $t("Common_Yes") }}</el-radio>
              <el-radio :label="false">{{ $t("Common_No") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="$t('ViewInvitation_ReasonofRejection')"
            v-if="checkRow.status == 2"
          >
            <el-input
              resize="none"
              disabled
              type="textarea"
              v-model="followForm.refuseReason"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="drawerBtns">
          <el-button
            class="confirmDialogBtn"
            v-loading.fullscreen.lock="fullscreenLoading"
            @click="followSubmit()"
            >{{
              checkRow.status == undefined
                ? $t("Common_Operate_AddInvite")
                : checkRow.status == 2
                ? $t("Common_Operate_InviteAgain")
                : $t("Common_Save")
            }}</el-button
          >
          <el-button class="cancelDialogBtn" @click="cancelDrawer()">{{
            $t("Common_CloseWindow")
          }}</el-button>
        </div>
      </div>
    </el-drawer>
    <div class="mobileLabelTips" ref="mobileLabelTips" v-if="isLableTips">
      <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
      <p>
        {{ labelTitle }}
      </p>
      <div>
        <div>
          {{ labelTxt }}
        </div>
        <br />
        <div v-if="labelSubContent">
          {{ labelSubContent }}
        </div>
      </div>
    </div>
    <el-drawer
      class="mobileSearchDrawer"
      :visible.sync="mobileSearchDrawer"
      direction="ttb"
    >
      <div class="mobileFilterReturnBtnDiv">
        <el-button
          class="mobileFilterReturnBtn"
          @click="mobileSearchDrawer = false"
        >
          {{ $t("Common_Search") }}
          <i class="el-icon-arrow-up"></i>
        </el-button>
      </div>

      <el-form
        label-position="top"
        :model="tableSearchForm"
        ref="tableSearchForm"
      >
        <el-form-item
          :label="$t('Common_TableTitle_Mt4Account')"
          prop="Account"
        >
          <el-input v-model="tableSearchForm.Account"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_CustomerEmail')"
          prop="LoginId"
        >
          <el-input v-model="tableSearchForm.LoginId"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_AutoMatchOrder')"
          prop="AutoRecon"
        >
          <el-select v-model="tableSearchForm.AutoRecon">
            <el-option :label="$t('Common_Yes')" value="true"></el-option>
            <el-option :label="$t('Common_No')" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_Status')"
          prop="FollowStatus"
        >
          <el-select v-model="tableSearchForm.FollowStatus">
            <el-option :label="$t('Common_AllStatus')" value=""></el-option>
            <el-option
              :label="$t('Common_InvitationStatus_Inviting0')"
              value="0"
            ></el-option>
            <el-option
              :label="$t('Common_InvitationStatus_AgreeWatingActivate4')"
              value="4"
            ></el-option>
            <el-option
              :label="$t('Common_InvitationStatus_BeRefuse2')"
              value="2"
            ></el-option>
            <el-option
              :label="$t('Common_InvitationStatus_Agree1')"
              value="1"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="mobileFilterBottomBtns">
        <el-button class="resetFormBtn" @click="resetForm()">
          {{ $t("Common_Reset") }}
        </el-button>
        <el-button class="serchFormBtn" @click="getData(1, pageSize, 'search')">
          {{ $t("Common_Search") }}
        </el-button>
      </div>
    </el-drawer>
    <PopupTips
      :popupVisible="isPopupVisible"
      :icon="iconImg"
      :title="$t('Common_Prompt')"
      @confirmPopupTips="confirmPopup"
      @cancelPopupTips="cancelPopup"
      ref="popupTipsRef"
      :isHtml="true"
      :confirmTxt="confirmTxt"
      :cancelTxt="cancelTxt"
      :subContent="$t(subContent)"
      :content="$t(popupContent)"
      :btnType="2"
    />

    <el-dialog
      :title="$t('Common_Operation_SettleAndUnbind')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      top="5vh"
    >
      <el-form
        :model="settleUnbindForm"
        :rules="rules"
        ref="settleUnbindForm"
        :label-position="mobileFlag ? 'top' : 'left'"
        @submit.native.prevent
        label-width="150px"
      >
        <el-form-item
          :label="$t('Common_TableTitle_CurrentBeginTime')"
          prop="currentSettlementBeginTime"
        >
          <el-input
            disabled
            v-model="settleUnbindForm.currentSettlementBeginTime"
            maxlength="40"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_InitialEquity')"
          prop="beginPeriodEquity"
        >
          <el-input
            disabled
            v-model="settleUnbindForm.beginPeriodEquity"
            maxlength="40"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_CurrentPeriodDeposit')"
          prop="currentPeriodDeposit"
        >
          <el-input
            disabled
            v-model="settleUnbindForm.currentPeriodDeposit"
            maxlength="40"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_SettlementEquity')"
          prop="endPeriodEquity"
        >
          <el-input
            disabled
            v-model="settleUnbindForm.endPeriodEquity"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_SignalPLSharingRatio')"
          prop="shareProfitPercent"
        >
          <el-input
            disabled
            v-model="settleUnbindForm.shareProfitPercent"
            placeholder="0-100"
          ></el-input>
          <b class="formPercent">%</b>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_PaymentProfitMoney')"
          prop="bouns"
        >
          <el-input
            v-model="settleUnbindForm.bouns"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <p class="settleUnbindTips" v-if="settleUnbindForm.settlementStatus == 1">
        {{ $t("SignalSource_CannotSettleUnbindTips") }}
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="confirmDialogBtn"
          v-if="settleUnbindForm.settlementStatus !== 1"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="settleUnbindSubmit()"
          >{{ $t("Common_Confirm") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { concatParams, concatTableData } from "../../plugins/common.js";
import { mapState } from "vuex";
import PopupTips from "@/components/moudule/PopupTips.vue";
import BScroll from "@better-scroll/core";
import Pullup from "@better-scroll/pull-up";
import { formatNumberFractionDigits } from "@/shared/utils/formatNumber.js";

BScroll.use(Pullup);

export default {
  name: "FollowAccount",
  components: {
    PopupTips,
  },
  computed: {
    ...mapState(["checkPortfolio", "userInfo", "mobileFlag", "token"]),
  },
  data() {
    var checkMaxVolumn = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(this.$t("Common_valid_CheckMaxVolumeNotNull"))
        );
      } else {
        if ((value = 0)) {
          callback(new Error(this.$t("Common_valid_CheckMaxVolumeNot0")));
        } else {
          callback();
        }
      }
    };
    var checkSymbol = (rule, value, callback) => {
      if (
        !this.followForm.forexSelect &&
        !this.followForm.energySelect &&
        !this.followForm.indicesSelect &&
        !this.followForm.metalsSelect &&
        !this.followForm.cryptoSelect
      ) {
        callback(new Error(this.$t("Common_valid_CheckSymbolNot")));
      } else {
        callback();
      }
    };
    var checkPercent = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(this.$t("Common_Valid_CheckCopyPercentNotNull"))
        );
      } else {
        var reg = /^([1-9]\d|[1-9]\d{2,4}|100000)$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t("Common_Valid_CheckCopyPercentNotF")));
        } else {
          callback();
        }
      }
    };
    return {
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 5,
      tableSearchForm: {
        Account: "",
        AutoRecon: "",
        Activation: "",
        FollowStatus: "",
        LoginId: "",
      },
      followAccountDrawer: false,
      fullscreenLoading: false,
      followForm: {
        loginId: "",
        following: 100,
        maxDrawdown: 0,
        maxVolume: undefined,
        symbols: [],
        autoRecon: true,
        agreeActivation: true,
        energySelect: true,
        forexSelect: true,
        indicesSelect: true,
        metalsSelect: true,
        cryptoSelect: true,
        symbolsCheck: [],
      },
      rules: {
        loginId: [
          {
            required: true,
            message: this.$t("Common_valid_CheckCustomAccountNotNull"),
            trigger: "blur",
          },
        ],
        symbolsCheck: [{ validator: checkSymbol, trigger: "change" }],
        following: [{ validator: checkPercent, trigger: "blur" }],
      },
      checkRow: {},
      reason: "",
      followAccountDrawerTitle: "",
      labelTitle: "",
      labelTxt: "",
      isLableTips: false,
      idList: [],
      isPopupVisible: false,
      iconImg: require("../../assets/images/NotifyWarning.svg"),
      popupContent: "",
      popupContentSub: "",
      clickType: "",
      totalProfit: 0,
      totalVolume: 0,
      cancelTxt: "Common_Cancel",
      confirmTxt: "Common_Confirm",
      subContent: "",
      labelSubContent: "",
      mobileSearchDrawer: false,
      selectionList: [],
      up: false,
      firstOpen: false,
      isEdit: false,
      isStatusDisabled: false,
      dialogVisible: false,
      settleUnbindForm: {},
    };
  },
  created() {
    this.getData(1, this.pageSize);
    this.screenClick();
  },
  methods: {
    formatNumberFractionDigits,
    collapseChange() {
      this.$nextTick(() => {
        if (!this.firstOpen) {
          this.scroll.maxScrollY = this.scroll.maxScrollY - 300;
          this.firstOpen = true;
        } else {
          this.scroll.maxScrollY = this.scroll.maxScrollY + 300;
          this.firstOpen = false;
        }
      });
    },
    scrollFn() {
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.bscroll, {
            click: true,
            scrollY: true,
            probeType: 3,
          });
        } else {
          this.scroll.refresh();
        }

        //touchEnd（手指离开以后触发） 通过这个方法来监听下拉刷新
        this.scroll.on("touchEnd", (pos) => {
          //上拉加载 总高度>下拉的高度+10 触发加载更多
          if (this.scroll.maxScrollY > pos.y + 50) {
            // console.log("加载更多")
            this.up = true;
            setTimeout(() => {
              //使用refresh 方法 来更新scroll  解决无法滚动的问题
              if (this.tableData.length < this.total) {
                this.currentPage = this.currentPage + 1;
                this.getData(this.currentPage, this.pageSize, "noRefresh");
                this.scroll.refresh();
                this.up = false;
              } else {
                this.up = false;
              }
            }, 1000);
          }
        });
      });
    },
    // 定义signal链接

    getData(pageIndex, pageSize, tag) {
      if (tag == "search") {
        this.currentPage = 1;
      }
      // debugger
      if (!this.mobileFlag || tag !== "noRefresh") {
        this.tableData = [];
      }
      var params = {
        portfolioId: this.checkPortfolio.id,
        account: this.tableSearchForm.Account.trim(),
        autoRecon: this.tableSearchForm.AutoRecon,
        status: this.tableSearchForm.FollowStatus,
        loginId: this.tableSearchForm.LoginId.trim(),
        pageIndex: pageIndex,
        pageSize: pageSize,
      };
       const loading = this.$loading({
        lock: true,
      });
      this.$axios
        .post("/Api/Portfolio/GetFollowListPage", params)
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.total = dt.result.total;
            this.totalProfit = dt.result.totalProfit;
            this.totalVolume = dt.result.totalVolume;
            if (this.mobileFlag && tag == "noRefresh") {
              dt.result.pageList.forEach((item) => {
                this.tableData.push(item);
              });
            } else {
              this.tableData = concatTableData(
                dt.result.pageList,
                dt.result.total,
                this.currentPage,
                this.pageSize
              );
            }

            this.fullscreenLoading = false;
            if (this.mobileFlag) {
              this.scrollFn();
            }
          }
        })
        .finally(() => {
          this.mobileSearchDrawer = false;
          loading.close();
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.currentPage, this.pageSize);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData(this.currentPage, this.pageSize);
    },
    resetForm() {
      this.$refs.tableSearchForm.resetFields();
      this.currentPage = 1;
      this.getData(this.currentPage, this.pageSize);
    },
    addFollow() {
      this.followAccountDrawerTitle = this.$t("Common_Operate_AddInvite");
      this.checkRow = {};
      this.$nextTick(() => {
        this.$refs.followForm.clearValidate();
      });
      this.followForm.forexSelect = true;
      this.followForm.energySelect = true;
      this.followForm.indicesSelect = true;
      this.followForm.metalsSelect = true;
      this.followForm.cryptoSelect = true;
      this.followAccountDrawer = true;
      this.isEdit = false;
      this.isStatusDisabled = false;
    },
    cancelDrawer() {
      this.$refs.followForm.resetFields();
      this.followAccountDrawer = false;
    },
    followSubmit() {
      this.$refs.followForm.validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          var params = {
            portfolioId: this.checkPortfolio.id,
            loginId: this.followForm.loginId.trim(),
            following: this.followForm.following,
            maxVolume:
              this.followForm.maxVolume == undefined
                ? 0
                : this.followForm.maxVolume,
            autoRecon: this.followForm.autoRecon,
            agreeActivation: this.followForm.agreeActivation,
            energySelect: this.followForm.energySelect,
            forexSelect: this.followForm.forexSelect,
            indicesSelect: this.followForm.indicesSelect,
            metalsSelect: this.followForm.metalsSelect,
            cryptoSelect: this.followForm.cryptoSelect,
            id: this.checkRow.id,
          };
          this.$axios
            .post("/Api/SubAccount/AddInvite", params)
            .then((res) => {
              let dt = res.data;
              if (dt.isSuccess) {
                this.$notify.success({
                  title: this.$t("Common_Prompt"),
                  message: this.$t("Common_OperateSuccess"),
                });
                this.getData(this.currentPage, this.pageSize);
                this.$refs.followForm.resetFields();
                this.followAccountDrawer = false;
              } else {
                this.$notify.error({
                  title: this.$t("Common_Prompt"),
                  message: dt.result,
                });
              }
            })
            .finally(() => {
              this.fullscreenLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 设置
    editFollow(row) {
      this.isEdit = true;
      if (row.status == 0) {
        this.isStatusDisabled = false;
      } else {
        this.isStatusDisabled = true;
      }
      this.followAccountDrawerTitle = this.$t("Common_Setting");
      this.checkRow = row;
      this.$axios.get("/Api/SubAccount/InviteSet?id=" + row.id).then((res) => {
        let dt = res.data;
        if (dt.isSuccess) {
          this.followAccountDrawer = true;
          this.$nextTick(function () {
            this.followForm = Object.assign(this.followForm, dt.result);
            this.followForm.maxVolume =
              this.followForm.maxVolume == 0
                ? undefined
                : this.followForm.maxVolume;
          });
        } else {
          this.$notify.error({
            title: this.$t("Common_Prompt"),
            message: dt.result,
          });
        }
      });
    },
    unbindOne() {
      const loading = this.$loading({
        lock: true,
      });
      var params = {
        portfolioId: this.checkPortfolio.id,
        id: this.checkRow.id,
      };
      this.$axios
        .get("/Api/SubAccount/UnBind" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });
            this.getData(this.currentPage, this.pageSize);
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    cancelPopup(val) {
      this.isPopupVisible = val;
      this.subContent = "";
    },
    confirmPopup(val) {
      this.isPopupVisible = val;
      this.subContent = "";
      if (this.clickType == "unbind") {
        this.unbindOne();
      } else if (this.clickType == "unbindAll") {
        this.unbindAll();
      } else if (this.clickType == "delete") {
        this.deleteInvite();
      }
    },
    // 激活
    activateFollow(row) {
      this.fullscreenLoading = true;
      var params = {
        id: row.id,
      };
      this.$axios
        .get("/Api/SubAccount/ActiveFollow" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });

            this.getData(this.currentPage, this.pageSize);
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    // 删除邀请
    retractFollow(row) {
      this.clickType = "delete";
      this.popupContent = "SignalSource_StopDeleteConfirm";
      this.checkRow = row;
      this.isPopupVisible = true;
    },
    deleteInvite() {
      this.fullscreenLoading = true;
      var params = {
        id: this.checkRow.id,
      };
      this.$axios
        .get("/Api/SubAccount/RecallInvite" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });

            const totalPage = Math.ceil((this.total - 1) / this.pageSize); // 总页数
            this.currentPage =
              this.currentPage > totalPage ? totalPage : this.currentPage;
            this.currentPage = this.currentPage < 1 ? 1 : this.currentPage;

            this.getData(this.currentPage, this.pageSize);
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    labelIconClick(title, content, subContent) {
      if (this.mobileFlag) {
        this.isLableTips = !this.isLableTips;
        this.labelTitle = title;
        this.labelTxt = content;
        this.labelSubContent = subContent;
      } else {
        this.isLableTips = false;
      }
    },
    screenClick() {
      // debugger
      document.addEventListener("click", (e) => {
        if (this.$refs.mobileLabelTips) {
          let self = this.$refs.mobileLabelTips.contains(e.target);
          if (!self) {
            this.isLableTips = false;
            this.labelSubContent = "";
          }
        }
      });
    },
    unbindAll() {
      this.fullscreenLoading = true;
      this.$axios
        .post("/Api/SubAccount/UnBindAll", {
          ids: this.mobileFlag ? this.selectionList : this.idList,
        })
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });

            this.getData(this.currentPage, this.pageSize);
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    selectable(row, index) {
      if (row.status == 1 || row.status == 4) {
        return true;
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("Common_Total");
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          column.property === "profit" ||
          column.property === "volumes" ||
          column.property === "equity" ||
          column.property === "balance"
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          sums[index] = formatNumberFractionDigits(sums[index]);
        } else {
          sums[index] = " ";
        }
      });

      return sums;
    },
    //获取数组中数值的下标
    indexOf(val, ids) {
      for (let i = 0; i < ids.length; i++) {
        //获取当前值的下标
        if (ids[i] === val) {
          return i;
        }
      }
      return -1;
    },

    //多选赋值ids
    ids(val) {
      //检索下标,判断当前值(或对象是否在数组中); 在则返回在的对象,不在则返回-1
      let index = this.indexOf(val, this.selectionList);
      if (this.selectionList.length > 0 && index > -1) {
        //删除数组中的某个元素(在取消勾选时,删除数组中的值)
        this.selectionList.splice(index, 1);
      } else {
        //id添加到数组中
        this.selectionList.push(val);
      }
    },

    goHistoryProfit(account) {
      this.$emit("GoHistory", "signalHistoricalProfit", account);
    },
    settleUnbind(row) {
      this.checkRow = row;
      this.fullscreenLoading = true;
      this.$axios
        .get("/Api/invite/StopFollowDetail?inviteId=" + row.id)
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.fullscreenLoading = false;
            this.dialogVisible = true;
            this.settleUnbindForm = dt.result;
            this.settleUnbindForm.currentPeriodDeposit =
              formatNumberFractionDigits(
                this.settleUnbindForm.currentPeriodDeposit
              );
            this.settleUnbindForm.beginPeriodEquity =
              formatNumberFractionDigits(
                this.settleUnbindForm.beginPeriodEquity
              );
            this.settleUnbindForm.endPeriodEquity = formatNumberFractionDigits(
              this.settleUnbindForm.endPeriodEquity
            );
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    settleUnbindSubmit() {
      this.$confirm(
        this.$t("SignalSource_SettleUnbindConfirmPromptForFollow"),
        this.$t("Common_Prompt"),
        {
          confirmButtonText: this.$t("Common_Confirm"),
          cancelButtonText: this.$t("Common_Cancel"),
          type: "warning",
        }
      ).then(() => {
        this.fullscreenLoading = true;
        this.$axios
          .get("/Api/Portfolio/SettltementInvitation?id=" + this.checkRow.id)
          .then((res) => {
            let dt = res.data;
            if (dt.isSuccess) {
              this.$notify.success({
                title: this.$t("Common_Prompt"),
                message: this.$t("Common_OperateSuccess"),
              });
              this.getData(this.currentPage, this.pageSize);
              this.dialogVisible = false;
            } else {
              this.$notify.error({
                title: this.$t("Common_Prompt"),
                message: dt.result,
              });
            }
          })
          .finally(() => {
            this.fullscreenLoading = false;
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.followAccount {
  .pageTitleBtn {
    margin-bottom: 20px;
  }
  .operateBtns {
    padding-left: 0;
  }
}
.refreshListBtnDiv {
  position: absolute;
  right: 0;
  top: -155px;
}
.clickClass {
  color: #4d71ff !important;
  cursor: pointer;
}
.settleUnbindTips {
  margin: 30px 0;
  border-top: 1px solid #d0d0d0;
  padding-top: 20px;
  color: #e35972;
}

@media screen and (max-width: 767px) {
  .mobileFilterDiv {
    justify-content: space-between;
  }
  .followAccount {
    .pageTitleBtn {
      margin: 20px 0 0 0;
    }
  }
  .serchFormBtn,
  .resetFormBtn {
    min-width: 150px;
  }
  .tableSearch {
    padding-top: 40px;
  }
  .refreshListBtnDiv {
    position: absolute;
    left: 0;
    top: 30px !important;
    .confirmDialogBtn {
      padding: 10px;
      font-size: 12px;
      line-height: 15px;
    }
  }

  .labelIconDiv {
    display: flex;
    flex-direction: row;
    .labelIconDivMobile {
      margin-left: 10px;
    }
  }
}
</style>
